import {
  Contact,
  Globe,
  Mail,
  MessageSquare,
  Phone,
  Type,
  Wifi,
} from 'lucide-react';
import { CONTENT_TYPES } from '../../utils/qrFormats';

const TABS = [
  { id: CONTENT_TYPES.url, label: 'Link', icon: Globe },
  { id: CONTENT_TYPES.text, label: 'Text', icon: Type },
  { id: CONTENT_TYPES.email, label: 'E-mail', icon: Mail },
  { id: CONTENT_TYPES.call, label: 'Call', icon: Phone },
  { id: CONTENT_TYPES.sms, label: 'SMS', icon: MessageSquare },
  { id: CONTENT_TYPES.vcard, label: 'V-card', icon: Contact },
  { id: CONTENT_TYPES.wifi, label: 'Wi-Fi', icon: Wifi },
];

export default function ContentTypeTabs({ active, onChange }) {
  return (
    <div
      className="grid grid-cols-3 gap-1.5 sm:grid-cols-4 sm:gap-2"
      role="tablist"
      aria-label="QR content type"
    >
      {TABS.map(({ id, label, icon: Icon }) => {
        const selected = active === id;
        return (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(id)}
            className={`flex flex-col items-center gap-1 rounded-lg px-1.5 py-2.5 text-[11px] font-medium transition sm:gap-1.5 sm:rounded-xl sm:px-2 sm:py-3 sm:text-xs ${
              selected
                ? 'bg-indigo-50 text-indigo-800 ring-2 ring-indigo-500'
                : 'bg-slate-50 text-slate-600 ring-1 ring-slate-200/80 hover:bg-white'
            }`}
          >
            <Icon className="h-5 w-5 shrink-0" strokeWidth={1.75} />
            {label}
          </button>
        );
      })}
    </div>
  );
}
